module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/45bfd46de0357ec381d51fc0f88011ea.png";